require ('./hirePromotionError.scss');

// @ vendors
const React = require('react');
// @ commons
const WizardError = require('components/commons/wizardError/wizardError');
// @ helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
// @ utilities
const { recordProcess, PROC_HIRE_PROMOTIONS, PROC_FAIL  } = require('utilities/tagging');

class HirePromotionError extends React.Component {
    componentDidMount() {
        recordProcess(PROC_HIRE_PROMOTIONS, PROC_FAIL);
    }
    render () {
        const exitLink = '/myprofile/global';
        const errorMessage = formatText('promotions-setPromotionErrorTitle');
        const mainButtonLabel = formatText('promotions-setPromotionErrorBackButtonLabel').toUpperCase();
        const mainButton = {
            label: mainButtonLabel,
            url: exitLink
        };

        return (
            <section className="hire-promotion-error">
                <WizardError
                    errorMessage={errorMessage}
                    mainButton={mainButton}
                >
                    <div className="hire-promotion-error__caption">
                        <FormattedText value="promotions-setPromotionErrorDetailTitle" />
                    </div>
                </WizardError>
            </section>
        );
    }
}

module.exports = HirePromotionError;
